import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import PrivateRoute from "components/PrivateRoute";

import mobileTheme from "./theme";
import MobileDashboard from "./screens/Dashboard";
import MobilePerformance from "./screens/Performance";
import MobileInterview from "./screens/Interview";
import MobileFeedback from "./screens/Feedback";
import MobileLogin from "./screens/Login";
import MobileProfile from "./screens/Profile";
import NotAvailable from "./screens/NotAvailable";

/**
 * MobileApp — the entire mobile UI tree, fully isolated from desktop.
 *
 * Rendered by `src/screens/index.jsx` when `isMobile()` is true, INSIDE the
 * shared provider + auth shell (SingleSessionProvider, SessionHelper, …), so
 * mobile shares the exact same session/auth/services as desktop and only the
 * UI differs.
 *
 * It wraps its subtree in the mobile theme and mirrors the desktop
 * `/:client/...` URL scheme. Any route not yet built for mobile resolves to
 * <NotAvailable/> — nothing here ever imports a desktop screen/component.
 */
export default function MobileApp() {
  return (
    <ThemeProvider theme={mobileTheme}>
      <Routes>
        <Route path=":client">
          <Route index element={<Navigate to="home" replace />} />

          {/* Unauthenticated entry — PrivateRoute redirects here. No shell. */}
          <Route path="login" element={<MobileLogin />} />

          <Route
            path="home"
            element={<PrivateRoute component={MobileDashboard} />}
          />

          <Route
            path="performance"
            element={<PrivateRoute component={MobilePerformance} />}
          />

          {/* Feedback / report for a single attempt. */}
          <Route
            path="performance/:aid"
            element={<PrivateRoute component={MobileFeedback} />}
          />

          <Route
            path="assessment"
            element={<PrivateRoute component={MobileInterview} />}
          />

          <Route
            path="profile"
            element={<PrivateRoute component={MobileProfile} />}
          />

          {/* Any other path (unbuilt/desktop-only features) lands here. */}
          <Route path="*" element={<NotAvailable />} />
        </Route>

        <Route path="/" element={<Navigate to="/languify/home" replace />} />
        <Route path="*" element={<NotAvailable />} />
      </Routes>
    </ThemeProvider>
  );
}
